/* ESLint in Brackets needs some extra information to be more helpful */
/* global
   downloadUrl:false,
   outing_file:false,
   ol:false
*/
/*
   eslint no-unused-vars: [
     "error", {
       "varsIgnorePattern": "resetMap|streetMap"
      }
  ]
*/

var map;
var bounds;
var osm;
var centrePoint = new ol.proj.fromLonLat([-2.0766, 51.9014]);
var cheltenham = new ol.proj.fromLonLat([-2.103649, 51.89302]); // Shelburne Road
var initialCheltOpenStreetMapZoom = 11;

// Extend the getters so we can group the popup text with the marker.
// This breaks Heatmaps, you click on the map, get an error as the property does not exist
ol.Feature.prototype.getPopup = function(){
  return this.getProperties().popup;
};

function initialize() {
  // Read in venues from an XML definition file.
  downloadUrl(outing_file, function(data) {
    var venues = data.documentElement.getElementsByTagName("venues")[0].childNodes;
    initOutingMap(venues);
  });
}

function initOutingMap(venues) {
  var markers = [];
  bounds = new ol.extent.createEmpty();
  var markerLayer = new ol.source.Vector();

  osm = new ol.layer.Tile({
    visible: true,
    source: new ol.source.OSM()
  });
  

  map = new ol.Map({
    layers: [
      osm
    ],
    // Improve user experience by loading tiles while dragging/zooming. Will make
    // zooming choppy on mobile or slow devices.
    loadTilesWhileInteracting: true,
    target: 'openstreetmap',
    controls: ol.control.defaults({
      attributionOptions: {
        collapsible: true
      }
    }).extend([
      new ol.control.ZoomSlider()
    ]),
    view: new ol.View({
      center: centrePoint,
      zoom: initialCheltOpenStreetMapZoom
    })
  });

  var bellIcons = [];
  for(var i = 0; i <= 12; i++) {
    switch (i) {
      case 0:
      case 1:
      case 2:
      case 7:
      case 9:
      case 11:
        bellIcons[i] = new ol.style.Style({
          image: new ol.style.Icon(({
            anchor: [0.5, 0.5],
            anchorXUnits: 'fraction',
            anchorYUnits: 'fraction',
            src: './graphics/bellx.gif'
          }))
        });
        break;
      default:
        bellIcons[i] = new ol.style.Style({
          image: new ol.style.Icon(({
            anchor: [0.5, 0.5],
            anchorXUnits: 'fraction',
            anchorYUnits: 'fraction',
            src: "./graphics/bell" + i + ".gif"
          }))
        });
    }
  }

  var breakIcon = new ol.style.Style({
    image: new ol.style.Icon(({
      anchor: [0.5, 1.0],
      anchorXUnits: 'fraction',
      anchorYUnits: 'fraction',
      src: "./graphics/restaurant.png"
    }))
  });
  
  var trekIcon = new ol.style.Style({
    image: new ol.style.Icon(({
      anchor: [0.5, 1.0],
      anchorXUnits: 'fraction',
      anchorYUnits: 'fraction',
      src: "./graphics/trek.png"
    }))
  });
  
  function createTowerMarker(tower) {
    var time = tower.getElementsByTagName("time")[0].firstChild.nodeValue;
    var location = tower.getElementsByTagName("location")[0];
    var popupId = location.getAttribute("osgrid");
    // Can be HTML
    var comment = tower.getElementsByTagName("comment");
    if (comment.length > 0) {
      comment = comment[0].firstChild.nodeValue;
    }
    var point = new ol.proj.fromLonLat([
      parseFloat(location.getAttribute("longitude")),
      parseFloat(location.getAttribute("latitude"))
    ]);
    var infoBox = '<p>' + time + "</p>";
    infoBox += '<p class="venue">' + location.firstChild.nodeValue + "</p>";
    infoBox += '<p>' + tower.getAttribute("bells") + ", " + tower.getAttribute("weight") + ", " + location.getAttribute("osgrid") + "</p>";
    if (location.getAttribute("postcode")) {
      infoBox += '<p>' + location.getAttribute("postcode") + "</p>";
    }
    var strArr = [];
    if (tower.getAttribute("doveID")) {
      strArr.push('<a href="http://dove.cccbr.org.uk/detail.php?DoveID=' + tower.getAttribute("doveID") + '" target="external">Dove Entry</a>');
    }
    if (tower.getAttribute("href")) {
      strArr.push('<a href="' + tower.getAttribute("href") + '" target="external">Local Website</a>');
    }
    if (strArr.length > 0) {
      infoBox += '<p>';
      infoBox += strArr.join(", ");
      infoBox += "</p>";
    }

    jQuery(
      '<div/>',
      {id: popupId}
    ).appendTo('#openstreetmap');
    $('#' + popupId).popover(
      jQuery.extend(
        {
          //title: location.firstChild.nodeValue + '<span class="close">&times;</span>',
          content: '<span class="close">&times;</span>' + infoBox
        },
        popupDefaults
      )
    ).on('shown.bs.popover', function() {
      // Popover for the quick search additional fields
      var item = $(this);
      item.parent().find('.popover .close').click(function() {
        item.popover('hide');
      });
    });

    var popup = new ol.Overlay({
      element: $('#' + popupId)[0],
      position: point
    });
    var marker = new ol.Feature({
      geometry: new ol.geom.Point(point),
      name: location.firstChild.nodeValue,
      popup: popup
    });
    marker.setStyle(bellIcons[parseInt(tower.getAttribute("bells"))]);
    markerLayer.addFeature(marker);
    map.addOverlay(popup);

    markers.push(marker);
    ol.extent.extend(
      bounds,
      ol.extent.boundingExtent([
        point
      ])
    );
  }

  function createBreakMarker(rest) {
    var time = rest.getElementsByTagName("time")[0].firstChild.nodeValue;
    var location = rest.getElementsByTagName("location")[0];
    var popupId = location.getAttribute("osgrid");
    // Can be HTML
    var comment = rest.getElementsByTagName("comment");
    if (comment.length > 0) {
      comment = comment[0].firstChild.nodeValue;
    }
    var point = new ol.proj.fromLonLat([
      parseFloat(location.getAttribute("longitude")),
      parseFloat(location.getAttribute("latitude"))
    ]);
      var infoBox = '<p>' + time + ", " + rest.getAttribute("type") + "</p>";
      infoBox += '<p class="venue">' + location.firstChild.nodeValue + "</p>";
      if (location.getAttribute("postcode")) {
        infoBox += '<p>' + location.getAttribute("postcode") + "</p>";
      }
      infoBox += '<p>' + location.getAttribute("osgrid") + "</p>";
      var strArr = [];
      if (rest.getAttribute("href")) {
        strArr.push('<a href="' + rest.getAttribute("href") + '" target="external">Local Website</a>');
      }
      if (strArr.length > 0) {
        infoBox += '<p>';
        infoBox += strArr.join(", ");
        infoBox += "</p>";
      }

    jQuery(
      '<div/>',
      {id: popupId}
    ).appendTo('#openstreetmap');
    $('#' + popupId).popover(
      jQuery.extend(
        {
          //title: location.firstChild.nodeValue + '<span class="close">&times;</span>',
          content: '<span class="close">&times;</span>' + infoBox
        },
        popupDefaults
      )
    ).on('shown.bs.popover', function() {
      // Popover for the quick search additional fields
      var item = $(this);
      item.parent().find('.popover .close').click(function() {
        item.popover('hide');
      });
    });

    var popup = new ol.Overlay({
      element: $('#' + popupId)[0],
      position: point
    });
    var marker = new ol.Feature({
      geometry: new ol.geom.Point(point),
      name: location.firstChild.nodeValue,
      popup: popup
    });
    marker.setStyle(breakIcon);
    markerLayer.addFeature(marker);
    map.addOverlay(popup);

    markers.push(marker);
    ol.extent.extend(
      bounds,
      ol.extent.boundingExtent([
        point
      ])
    );
  }

  function createStartMarker() {
    var popupId = "start";
    jQuery(
      '<div/>',
      {id: popupId}
    ).appendTo('#openstreetmap');
    $('#' + popupId).popover(
      jQuery.extend(
        {
          title: "Cheltenham" + '<span class="close">&times;</span>',
          content: "<p>Home!</p>",
          // Adjust the default template to include an additional class, 'home'
          template: '<div class="popover home" role="tooltip">' +
                    '<div class="arrow"></div>' +
                    '<h3 class="popover-title"></h3>' +
                    '<div class="popover-content"></div>'
        },
        popupDefaults
      )
    ).on('shown.bs.popover', function() {
      // Popover for the quick search additional fields
      var item = $(this);
      item.parent().find('.popover .close').click(function() {
        item.popover('hide');
      });
    });

    var popup = new ol.Overlay({
      element: $('#' + popupId)[0],
      position: cheltenham
    });
    var marker = new ol.Feature({
      geometry: new ol.geom.Point(cheltenham),
      name: "Cheltenham",
      popup: popup
    });
    marker.setStyle(trekIcon);
    markerLayer.addFeature(marker);
    map.addOverlay(popup);
  }

  var popupDefaults = {
    placement: 'top',
    html: true,
    delay: {
      show: 100,
      hide: 100
    }
  };
  
  createStartMarker();

  // Perform actions for each venue (tower or lunch)
  for (i = 0; i < venues.length; i++) {
//    alert(i + ": " + venues[i].nodeName);
    // Firefox and Chrome create additional entries into venues[] over IE.
    if (venues[i].nodeName != "#text") {
      if (venues[i].nodeName == "tower") {
        createTowerMarker(venues[i]);
      } else if (venues[i].nodeName == "break") {
        createBreakMarker(venues[i]);
      }
    }
  }

  map.addLayer(
    new ol.layer.Vector({
      source: markerLayer
    })
  );

  // display popup on click
  map.on('click', function(evt) {
    var feature = map.forEachFeatureAtPixel(
      evt.pixel,
      function(feature) {
        return feature;
      }
    );
    // Affect all but the feature clicked
    markerLayer.getFeatures().forEach(function(f) {
      if (f != feature) {
        if (typeof f.getPopup() !== 'undefined') {
          $(f.getPopup().getElement()).popover('hide');
        }
      }
    });
    if (feature) {
      // Need to test if we click the heatmap element or the icon.
      // 'feature.getPopup().getElement()' is equivalent to ID of the marker e.g.'#something'
      var element = feature.getPopup();
      if (typeof element !== 'undefined') {
        $(element.getElement()).popover('toggle');
      }
    }
  });

  // change mouse cursor when over marker
  map.on('pointermove', function(e) {
    var pixel = map.getEventPixel(e.originalEvent);
    var hit = map.hasFeatureAtPixel(pixel);
    $('#' + map.getTarget()).css('cursor', hit ? 'pointer' : '');
  });

  var incchelt = ol.extent.buffer(
    ol.extent.extend(
      ol.extent.extend(
        ol.extent.createEmpty(),
        bounds
      ),
      ol.extent.boundingExtent([cheltenham])
    ),
    100
  );
  map.getView().fit(
    incchelt,
    {
      size:    map.getSize(),
      padding: [50, 50, 50, 50]
    }
  );
}

function resetMap() {
  map.getView().fit(
    bounds,
    {
      size:    map.getSize(),
      padding: [50, 50, 50, 50]
    }
  );
}

function streetMap() {
  osm.setVisible(true);
}

$(document).ready(function() {
  initialize();
});
